import React, {useEffect, useState} from "react";
import {useParams, NavLink, useNavigate} from "react-router-dom";
import validator from "validator";
import {checkResetToken, resetPassword} from "../../../services/AuthService";
import {toast} from "react-toastify";
import Utils from "../../../utils";
import {PASSWORD_RULES} from "../../../configs/AppConfig";
import {motion} from 'framer-motion';
import {FaEye, FaEyeSlash, FaCheck, FaTimes} from 'react-icons/fa';
import './AuthPages.css';
import Logo from '../../../assets/Images/Docusafe_logo.webp';


function ResetPassword() {
    const navigate = useNavigate();
    const {token} = useParams();
    const [loading, setLoading] = useState(false);
    const [isReset, setIsReset] = useState(1);
    const [passwordRules, setPasswordRules] = useState(PASSWORD_RULES);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isShowPasswordContain, setIsShowPasswordContain] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    let errorsObj = {
        password: '',
        confirm_password: '',
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(function () {
        setLoading(true);
        checkResetToken({token: token})
            .then(response => {
                setLoading(false);
            })
            .catch(err => {
                setIsReset(3);
                setLoading(false);
            });
    }, [token]);

    const handlePassword = (e) => {
        let value = e.target.value;
        setPassword(value);
        let passwordRule = [...passwordRules];
        const isContainsUppercase = /^(?=.*[A-Z]).*$/;
        const isContainsLowercase = /^(?=.*[a-z]).*$/;
        const isContainsNumber = /^(?=.*[0-9]).*$/;
        const isContainsSymbol = /^(?=.*[~!@#$%^&]).*$/;

        if (value.length >= 8 && value.length <= 15) {
            let index = passwordRule.findIndex(x => x.id === 1);
            if (index > -1) {
                passwordRule[index].active = true;
            }
        } else {
            passwordRule[0].active = false;
        }

        if (isContainsUppercase.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 2);
            if (index > -1) {
                passwordRule[index].active = true;
            }
        } else {
            passwordRule[1].active = false;
        }

        if (isContainsLowercase.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 3);
            if (index > -1) {
                passwordRule[index].active = true;
            }
        } else {
            passwordRule[2].active = false;
        }

        if (isContainsNumber.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 4);
            if (index > -1) {
                passwordRule[index].active = true;
            }
        } else {
            passwordRule[3].active = false;
        }

        if (isContainsSymbol.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 5);
            if (index > -1) {
                passwordRule[index].active = true;
            }
        } else {
            passwordRule[4].active = false;
        }

        setPasswordRules(passwordRule);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = {...errorsObj};
        const isContainsSymbol = /^(?=.*[~!@#$%^&]).*$/;

        if (!password) {
            errorObj.password = 'Password is required';
            error = true;
        } else if (!validator.isLength(password, {
            min: 8,
            max: 15
        })) {
            error = true;
        } else if (!isContainsSymbol.test(password)) {
            error = true;
        }

        if (!confirmPassword) {
            errorObj.confirm_password = 'Confirm password is required';
            error = true;
        } else if (confirmPassword !== password) {
            errorObj.confirm_password = 'Passwords do not match';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        resetPassword({password, token})
            .then(response => {
                setIsReset(2);
                setLoading(false);
                toast.success('Password reset successfully');
                navigate('/login');
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    return (
        <div className="auth-container">
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                </div>
            )}

              <div>
                    <img src={Logo} alt="Logo" className="login-logo" />
                </div>

            <motion.div 
                className="auth-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
              
                {isReset === 1 && (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                            <h2 style={{ 
                                fontSize: '1.875rem',
                                color: 'var(--text-color)',
                                marginBottom: '0.5rem'
                            }}>
                                Reset Password
                            </h2>
                            <p style={{ color: '#718096' }} className="mb-0">
                                Create a new password for your account
                            </p>
                        </div>

                        <motion.form 
                            onSubmit={onSubmit}
                            className="auth-form"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2 }}
                        >
                            <div className="form-group">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    value={password}
                                    onChange={handlePassword}
                                    onFocus={() => setIsShowPasswordContain(true)}
                                    placeholder=" "
                                    className={errors.password ? 'error' : ''}
                                />
                                <label>New Password</label>
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '1rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: '#718096',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                                </button>
                                {errors.password && <span className="error-message">{errors.password}</span>}
                            </div>

                            {isShowPasswordContain && (
                                <motion.div 
                                    className="password-rules"
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <p style={{ fontWeight: 500, marginBottom: '0.5rem' }}>Password must contain:</p>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        {passwordRules.map((rule, index) => (
                                            <li key={index} className={`password-rule ${rule.active ? 'valid' : 'invalid'}`}>
                                                {rule.active ? <FaCheck /> : <FaTimes />}
                                                {rule.text}
                                            </li>
                                        ))}
                                    </ul>
                                </motion.div>
                            )}

                            <div className="form-group">
                                <input
                                    type={confirmPasswordVisible ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder=" "
                                    className={errors.confirm_password ? 'error' : ''}
                                />
                                <label>Confirm Password</label>
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '1rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: '#718096',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                </button>
                                {errors.confirm_password && <span className="error-message">{errors.confirm_password}</span>}
                            </div>

                            <button type="submit" className="login-btn-page w-100">
                                Reset Password
                            </button>
                        </motion.form>
                    </>
                )}

                {isReset === 2 && (
                    <motion.div 
                        className="success-message"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="success-icon">✓</div>
                        <h3>Password Reset Successful!</h3>
                        <p>Your password has been changed successfully.</p>
                        <NavLink to="/login" className="login-btn-page w-100">
                            Back to Login
                        </NavLink>
                    </motion.div>
                )}

                {isReset === 3 && (
                    <motion.div 
                        className="error-message"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="error-icon">!</div>
                        <h3>Link Expired</h3>
                        <p>Your password reset link has expired.</p>
                        <NavLink to="/forgot-password" className="auth-button">
                            Request New Link
                        </NavLink>
                    </motion.div>
                )}
            </motion.div>
        </div>
    );
}

export default ResetPassword;